<template>
  <div>
    <v-row class="pt-10">
      <v-col>
        <h3>Drs</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-simple-table fixed-header height="300">
          <thead>
            <th class="text-left">Number</th>
            <th class="text-left">Customer</th>
            <th class="text-left">Date</th>
            <th class="text-left">Site</th>
            <th class="text-left">Sales Person</th>
            <th>&nbsp;</th>
          </thead>
          <tbody>
            <tr v-for="(dr, index) in drs" :key="`i_${index}`">
              <td>{{ dr.job_no }}</td>
              <td>
                <router-link :to="`/customers/view/${dr.customerId}`">
                  {{ dr.customer }}
                </router-link>
              </td>
              <td>{{ dr.date | prettyDate }}</td>
              <td>{{ dr.site }}</td>
              <td>{{ dr.sales_person }}</td>
              <td class="pr-0">
                <router-link :to="`/drs/view/${dr.id}`">
                  <v-btn x-small>View</v-btn>
                </router-link>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'SearchResultDrs',
  props: [
    'drs',
  ],
};
</script>
